var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2012,
    y: 0.707031,
    width: 56,
    height: 56,
    rx: 12,
    transform: "rotate(15 18.2012 0.707031)",
    fill: "#41A8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_42313_3995)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 42.6663H17.5M32.6667 33.333V37.9997M23.3333 33.333V37.9997M23.1 56.6663H32.9C34.8602 56.6663 35.8403 56.6663 36.589 56.2849C37.2475 55.9493 37.783 55.4139 38.1185 54.7553C38.5 54.0066 38.5 53.0265 38.5 51.0663V41.2663C38.5 39.3062 38.5 38.3261 38.1185 37.5774C37.783 36.9188 37.2475 36.3834 36.589 36.0478C35.8403 35.6663 34.8602 35.6663 32.9 35.6663H23.1C21.1398 35.6663 20.1597 35.6663 19.411 36.0478C18.7525 36.3834 18.217 36.9188 17.8815 37.5774C17.5 38.3261 17.5 39.3062 17.5 41.2663V51.0663C17.5 53.0265 17.5 54.0066 17.8815 54.7553C18.217 55.4139 18.7525 55.9493 19.411 56.2849C20.1597 56.6663 21.1398 56.6663 23.1 56.6663Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_42313_3995",
    x: -16,
    y: 1,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_42313_3995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_42313_3995",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.6c74cc2be16c67e7efc79217884495a8.svg";
export { ForwardRef as ReactComponent };